import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const socket = io(SOCKET_URL, {
	path: "/socket.io",
	transports: ["websocket", "polling"],
	reconnectionAttempts: 5,
	reconnectionDelay: 1000,
	timeout: 10000,
});

// socket.on("connect", () => console.log("🟢 Socket conectado:", socket.id));
// socket.on("disconnect", (reason) =>
// 	console.log("⚠️ Socket desconectado:", reason)
// );
// socket.on("connect_error", (err) =>
// 	console.error("❌ Error de conexión:", err.message)
// );
